import { Component, OnInit } from '@angular/core';
import { NewsletterFooterService } from '../../../services/newsletters/newsletter-footer.service';
import { NotyService } from '../../../services/common/noty.service';
@Component({
  selector: 'app-newsletter-footer-index',
  templateUrl: './newsletter-footer-index.component.html',
  styleUrls: ['./newsletter-footer-index.component.scss'],
})
export class NewsletterFooterIndexComponent implements OnInit {
  newsletterFooters: Array<any> = [];
  searchTerm: String = '';
  paginateParams: any = {
    page: 1,
    per_page: 5,
  };
  maxCount: number;
  constructor(private newsletterFooterService: NewsletterFooterService, private notyService: NotyService) {}

  ngOnInit() {
    this.newsletterFooterService
      .searchOptions({ angular: true, search_options: true })
      .then((success) => {
        this.paginateParams.per_page = success.per_page;
        console.log('searchOptions success', success);
        this.index();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  goToRailsPage(event: Event, url: string) {
    event.preventDefault();
    const token = window.localStorage.getItem('token');
    const separator = url.includes('?') ? '&' : '?';
    window.location.href = token ? `${url}${separator}token=${encodeURIComponent(token)}` : url;
  }

  index = (pageEvent: any = null) => {
    if (pageEvent) this.paginateParams.page = pageEvent.page;
    let { page, per_page } = this.paginateParams;
    this.newsletterFooterService
      .index({ page, per_page, angular: true })
      .then((indexRe) => {
        console.log('indexRe', indexRe);
        indexRe.newsletter_footers.forEach((element: any) => {
          element.isDeleting = false;
        });
        this.newsletterFooters = indexRe.newsletter_footers;
        this.maxCount = indexRe.max_count;
      })
      .catch((indexEr) => {
        console.log('index error', indexEr);
      });
  };

  searchNewsletterFooters = (pageEvent: any = null) => {
    console.log('search term', this.searchTerm);
    if (pageEvent) this.paginateParams.page = pageEvent;
    let { page, per_page } = this.paginateParams;
    this.newsletterFooterService
      .index({ angular: true, name: this.searchTerm })
      .then((searchRes) => {
        console.log('search response', searchRes);
        this.newsletterFooters = searchRes.newsletter_footers;
      })
      .catch((searchErr) => {
        console.log('searchErr', searchErr);
      });
  };

  deleteNewsletterFooter = (newsletterFooter: any, id: number) => {
    newsletterFooter.isDeleting = true;
    this.newsletterFooterService
      .delete({ angular: true, id })
      .then((deleteRes) => {
        console.log('delete response', deleteRes);
        this.notyService.notify('Newsletter Footer deleted', 'success');
        newsletterFooter.isDeleting = false;
        this.index();
      })
      .catch((deleteErr) => {
        console.log('delete error', deleteErr);
      });
  };
}
